<template>
    <div>
        <v-container v-if="this.asset && !this.loading">
            <v-row>
                <v-col cols="12" class="py-1 px-0"><v-btn color="addStuff" tile block @click="redirect()">Tillbaka</v-btn></v-col>
            </v-row>
            <v-row>
                <v-col cols="5" class="col asset-label">Namn: </v-col>
                <v-spacer></v-spacer>
                <!--<v-col cols="8"><input v-model="asset.name"></v-col>-->
                <v-col cols="7" class="col px-3 data">{{ asset.name }} {{ asset.assetNo }}</v-col>
            </v-row>
            <v-row class="row-background">
                <v-col cols="5" class="col asset-label">Typ: </v-col>
                <!--<v-col cols="8"><input v-model="asset.assetTypeName"></v-col>-->
                <v-col cols="7" class="col px-3 data">{{ asset.assetTypeName }}</v-col>
            </v-row>
            <v-row>
                <v-col cols="5" class="col asset-label">Beskrivning: </v-col>
                <!--<v-col cols="8"><input v-model="asset.description"></v-col>-->
                <v-col cols="7" class="col px-3 data">{{ asset.description }}</v-col>
            </v-row>
            <v-row class="row-background">
                <v-col cols="5" class="col asset-label">Kund: </v-col>
                <v-col cols="7" class="col px-3 data">{{ customerNo }} <br> {{ asset.customerName }}</v-col>
            </v-row>
            <v-row>
                <v-col cols="5" class="col asset-label">Kundprojekt: </v-col>
                <v-col cols="7" class="col px-3 data">{{ customerProjectNo }} <br> {{ asset.customerProjectName }}</v-col>
            </v-row>
            <v-row class="row-background">
                <v-col cols="5" class="col asset-label">Plats: </v-col>
                <v-col cols="7" class="col px-3 data">{{ location }}</v-col>
            </v-row>
            <v-row>
                <v-col cols="5" class="col asset-label">Platsbeskrivning: </v-col>
                <v-col cols="7" class="col px-3 data">{{ asset.locationDescription }}</v-col>
            </v-row>
            <v-row class="row-background" v-if="statusField">
                <customfield :field="statusField" :index="0" @update:value="updateAssetStatus($event); updateChangedData($event, statusField)"></customfield>
            </v-row>
            <v-row v-for="(customField, index) in asset.customFields" :key="customField.name" :class="index % 2 != 0 ? 'row-background' : ''">
                <v-col>
                    <customfield
                        v-if="!customField.internal"
                        :field="customField"
                        :index="index"
                        :yearlyInspection="yearlyInspection"
                        @update:value="asset.customFields[index].value = $event; updateChangedData($event, customField)"
                    ></customfield>
                </v-col>
            </v-row>
            <v-row v-if="saveNoQuestionsAsked">
                <v-col cols="12" class="py-1 px-0 bottom">
                    <v-btn color="addStuff" ref="updateAssetNoQuestionAsked" tile block :disabled="yearlyInspection ? !inspectorAdded : false" @click="clickApproveSave()">Spara</v-btn>
                    </v-col>
            </v-row>
            <v-row v-else>
                <v-dialog v-model="agreeToSave" persistent max-width="290">
                    <template v-slot:activator="{ on, attrs }">
                        <v-col cols="12" class="py-1 px-0 bottom"><v-btn color="addStuff" ref="updateAsset" tile block v-bind="attrs" v-on="on" :disabled="yearlyInspection ? !inspectorAdded : false">Spara</v-btn></v-col>
                    </template>
                    <v-card>
                        <v-card-title>Är du säker?</v-card-title>
                        <v-card-text>Vill du skriva över och spara Anläggningstillgången/Maskinpark med ny information?</v-card-text>
                        <v-spacer></v-spacer>
                        <v-btn color="red lighten-1" width="120" tile @click="agreeToSave = false">Nej</v-btn>
                        <v-btn color="green lighten-1" width="120" style="float:right;" tile @click="clickApproveSave()">Ja</v-btn>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
        <div v-else-if="this.loading">
            <v-progress-linear
                indeterminate
                color="primary"
                height="2">
            </v-progress-linear>
        </div>
        <div v-else>Drum roll...</div>
        <v-snackbar
            app
            v-model="snackbar"
            multi-line
            :color="this.errorMessage ? 'red accent-4' : 'green'"
            :top=true
            timeout="3000"
        >
            {{ successMessage ? successMessage : errorMessage }}
        </v-snackbar>
    </div>
</template>

<script>
import Customfield from './Customfield.vue';
export default {
    'name': 'Asset',
    props: {
        id: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        from: {
            type: String,
            required: true
        },
        customerProject: {
            type: Object,
            required: false
        },
        basicFormComplete: {
            type: Boolean,
            required: false
        },
        yearlyInspection: {
            type: Boolean,
            required: false
        },
        resourceName: {
            type: String,
            required: false
        }
    },
    mounted() {
        this.fetchAsset();
    },
    beforeRouteEnter(to, from, next) {
        // when pressing browser forward button after have been on an Asset to "get back" to that asset, params are not included - disallow forward into asset
        if (!to.params.id) next(false);
        else next();
    },
    data: () => ({
        loading: false,
        asset: null,
        assetFormTemplate: null,
        statusField: null,
        successMessage: null,
        errorMessage: null,
        snackbar: false,
        agreeToSave: false,
        oldCustomFields: null,
        changedData: ''
    }),
    methods: {
        fetchAsset() {
            this.loading = true;
            this.$api.get('get_asset/' + this.id + '/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                    this.asset = response.data;
                    if (this.yearlyInspection) {
                        this.oldCustomFields = JSON.parse(JSON.stringify(response.data.customFields));
                        let inspectorField = response.data.customFields.find( field => field.name == 'besiktadavleverantr');
                        if (inspectorField && !inspectorField.value) inspectorField.value = this.resourceName;
                    }
                    this.fetchFormTemplates();
                }, this)
                .catch( error => {
                    this.asset = null;
                    console.error('could not fetch asset: ' + error);
                    this.snack('could not fetch asset: ' + error);
                }, this)
                .finally(() => {
                    this.loading = false;
                }, this);
        },
        fetchFormTemplates() {
            this.loading = true;
            this.$api.get('get_form_templates/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                    let formTemplates = response.data;
                    if (formTemplates && formTemplates.length > 0) {
                        this.assetFormTemplate = formTemplates.find(template => template.title.toLowerCase() == this.type.toLowerCase());
                        if (this.assetFormTemplate) this.statusField = this.assetFormTemplate.fields.find(field => field.name == 'generellstatus');
                        if (this.statusField) {
                            this.setupStatusField();
                            this.oldStatusField = JSON.parse(JSON.stringify(this.statusField));
                        }
                    }
                }, this)
                .catch(error => {
                    console.error(error)
                }, this)
                .finally(() => {
                    this.loading = false;
                }, this)
        },
        clickApproveSave() {
            this.agreeToSave = false;
            this.saveAsset();
        },
        saveAsset() {
            this.loading = true;
            if (this.yearlyInspection) {
                let changedDataField = this.asset && this.asset.customFields && this.asset.customFields.find( field => field.name == 'ndringsnoteringar');
                if (changedDataField) {
                    if (changedDataField.value != this.changedData) {
                        changedDataField.value += this.changedData;
                    }
                }
            }
            let asset = JSON.stringify(this.asset);
            this.$api.post('post_asset/' + this.$jobId + '?access_token=' + this.$accessToken, asset)
                .then(response => {
                    this.asset = response.data;
                    this.$root.$emit('asset-updated', response.data);
                    this.snack(asset.name + ' uppdaterad');
                    this.redirect();
                }, this)
                .catch( error => {
                    this.asset = null;
                    console.error('could not update asset: ' + error);
                    this.snack('could not update asset: ' + error);
                }, this)
                .finally(() => {
                    this.loading = false;
                }, this);
        },
        updateAssetStatus(input) {
            if (!input) return false;
            this.asset.state = this.setAssetState(input);
            this.asset.labels = this.setAssetLabel(input);
        },
        setAssetState(selectedStatus) {
            if (selectedStatus.indexOf('X') == 0) return 'OUT_OF_ORDER';
            if (selectedStatus.indexOf('-/-') == 0) return 'DISCARDED';
            else return 'IN_USE';
        },
        setAssetLabel(selectedStatus) {
            if (!selectedStatus) return [];
            if (selectedStatus.indexOf('1') == 0) return ['Mycket dåligt skick'];
            else if (selectedStatus.indexOf('2') == 0) return ['Bör bytas på sikt'];
            else if (selectedStatus.indexOf('3') == 0) return ['Bra skick'];
            else if (selectedStatus.indexOf('4') == 0) return ['Mycket bra skick'];
            else if (selectedStatus.indexOf('5') == 0) return ['Under garanti'];
            else return [];
        },
        setupStatusField() {
            if (this.asset) {
                if (this.asset && this.asset.labels && this.asset.labels.length > 0) {
                    let label = this.asset.labels[0].toLowerCase();
                    this.statusField.value = this.statusOptions.find(option => option.toLowerCase().includes(label));
                } else if (this.asset.state) {
                    if (this.asset.state == 'OUT_OF_ORDER') {
                        this.statusField.value = this.statusOptions.find(option => option.includes('X.'));
                    } else if (this.asset.state == 'DISCARDED') {
                        this.statusField.value = this.statusOptions.find(option => option.includes('-/-'));
                    } else {
                        this.statusField.value = 'Välj status här';
                    }
                }
            }
        },
        updateChangedData(event, field) {
            if (!this.yearlyInspection) return;
            let fieldName = field.name;
            if (fieldName) {
                let oldField = fieldName == 'generellstatus' ? this.oldStatusField : this.oldCustomFields.find( old => old.name == field.name );
                let oldFieldValue = oldField && oldField.value
                if (fieldName == 'senastebesiktad' && !oldFieldValue) return;
                if (oldFieldValue && oldFieldValue != event) {
                    if (fieldName == 'senastebesiktad' && oldFieldValue.toString().indexOf('-') < 0) {
                        oldFieldValue = new Date(parseInt(oldFieldValue)).toISOString().substring(0, 10);
                    }
                    this.changedData += oldField.label + ': ' + oldFieldValue + '\n';
                }
            }
        },
        snack(msg, success) {
            if (success) {
                this.errorMessage = null;
                this.successMessage = msg;
            } else {
                this.successMessage = null;
                this.errorMessage = msg;
            }
            this.snackbar = true
            setTimeout(() => {
                this.successMessage = null
                this.errorMessage = null
                this.snackbar = false
            }, 3000)
        },
        redirect() {
            if (this.from == 'job') this.$router.push({ name: 'Job'})
            if (this.from == 'protocol') {
                this.$router.push({ name: 'Protocol', params: { basicFormComplete: this.basicFormComplete }});
            }
        }
    },
    computed: {
        customerNo() {
            return this.asset.customerNo ? this.asset.customerNo.toString() : this.asset.customerNoText;
        },
        customerProjectNo() {
            return this.asset.customerProjectNo ? this.asset.customerProjectNo.toString() : this.asset.customerProjectNoText;
        },
        location() {
            return this.asset.location && this.asset.location.placeName;
        },
        statusOptions() {
            return this.statusField && this.statusField.typeInfo.split('\n');
        },
        inspectorAdded() {
            return this.asset && this.asset.customFields
                    && this.asset.customFields.find( field => field.name == 'besiktadavleverantr')
                    && this.asset.customFields.find( field => field.name == 'besiktadavleverantr').value
                    && this.asset.customFields.find( field => field.name == 'besiktadavleverantr').value.length > 0;
        },
        saveNoQuestionsAsked() {
            return this.yearlyInspection && this.changedData.length === 0;
        }
    },
    components: {
        Customfield
    }
}
</script>
<style scoped>
    .asset-label {
        font-weight: bold;
        word-wrap: break-word;
        font-size: 14px;
        text-align: right;
    }
    .col {
        padding: 4px;
    }
    .row-background {
        background-color: #f5f5f5;
    }
</style>